import { View, useWindowDimensions } from 'react-native-web';

import DiscoverBody from './DiscoverBody';
import responsiveStyles from './styles';
import { DiscoverHeader, DiscoverFilters } from './components';

const Discover = () => {
  const layout = useWindowDimensions();
  const styles = responsiveStyles(layout, 1024);

  return (
    <>
      <DiscoverHeader />
      <View style={styles('discoverContainer')}>
        <DiscoverFilters />
        <DiscoverBody />
      </View>
    </>
  );
};

export default Discover;
